import React from "react";
import { Button, Space, DatePicker, version } from "antd";
import { ConfigProvider } from "antd";
import MyApp from "./MyApp";
import { Bounce, ToastContainer } from "react-toastify";
import { ConfigProviders } from "./config";

const App = () => (
  <>
    <ToastContainer
      position="top-right"
      autoClose={1000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick={false}
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
      transition={Bounce}
    />
    <ConfigProviders>
    <MyApp />
    </ConfigProviders>
  </>
);

export default App;
